import type { TourProgressAdapter } from '@klonup/design-system';
import { BackendTourProgressAdapter } from '../../BackendTourProgressAdapter';
import { OnboardingHttpRepository } from '../OnboardingHttpRepository';

export class OnboardingDependencyContainer {
  private static tourProgressAdapter: TourProgressAdapter | null = null;

  static getTourProgressAdapter(): TourProgressAdapter {
    if (!this.tourProgressAdapter) {
      this.tourProgressAdapter = new BackendTourProgressAdapter(new OnboardingHttpRepository());
    }
    return this.tourProgressAdapter;
  }

  static setTourProgressAdapter(adapter: TourProgressAdapter): void {
    this.tourProgressAdapter = adapter;
  }

  static reset(): void {
    this.tourProgressAdapter = null;
  }
}
